import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const suggestionService = () => {
    return axiosInstance.post(`healthcare_providers/investigation/suggestion`, {
        pageNo: 1,
        pageSize: 10,
    });
}

export const getDashboardData = () => {
    return axiosInstance.post(`/api/dashboard/stats`, {});
}

export const getDashboarGraph = () => {
    return axiosInstance.post(`/api/dashboard/daily-collection`, {});
}

export const getDashboarSample = () => {
    return axiosInstance.post(`/api/dashboard/daily-test`, {});
}


